module.exports = __webpack_public_path__ + "static/media/Layer 1.a6ddb01c.svg";